module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('drop-zone', {
    ref: "uploadImages",
    class: {
      error: _vm.error
    },
    attrs: {
      "id": "upload",
      "url": _vm.uploadUrl,
      "dropzoneOptions": _vm.dropzoneOptions,
      "useCustomDropzoneOptions": true
    },
    on: {
      "vdropzone-success": _vm.dzSuccess,
      "vdropzone-error": _vm.dzError,
      "vdropzone-removed-file": _vm.dzRemovedFile
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e1de870"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/file-upload/FileUpload.vue
// module id = 935
// module chunks = 1